import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.financial.'

@vsingleton()
export class AdminInvoiceItemRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'invoices.'

  destroy(invoiceItemId: number) { //todo
    return this.ziggyRoute('destroy', invoiceItemId)
  }


}
